import { createSlice } from "@reduxjs/toolkit";
import { addInventory, getInventory, getInventoryHistory, mangeInventory, editInventory } from "../../builders/inventory/inventory.builder";

const initialState = {
    loading: false,
    inventoryData: [],
    inventoryHistory:[]
};

const inventorySlice = createSlice({
    name: "inventory",
    initialState,
    reducers: {
       
        clearExtraReducers  : (state) =>{
           state.loading = false,
           state.inventoryData = []
           state.inventoryHistory = []
          },
      },
    extraReducers: (builder) => {
    
        builder.addCase(getInventory.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getInventory.fulfilled, (state, action) => {
            state.loading = false
            state.inventoryData = action.payload
        });
        builder.addCase(getInventory.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(addInventory.pending, (state) => {
            state.loading = true
        });
        builder.addCase(addInventory.fulfilled, (state) => {
            state.loading = false

        });
        builder.addCase(addInventory.rejected, (state) => {
            state.loading = false
        });


        builder.addCase(mangeInventory.pending, (state) => {
            state.loading = true
        });
        builder.addCase(mangeInventory.fulfilled, (state) => {
            state.loading = false

        });
        builder.addCase(mangeInventory.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(getInventoryHistory.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getInventoryHistory.fulfilled, (state, action) => {
            state.loading = false
            state.inventoryHistory = action.payload

        });
        builder.addCase(getInventoryHistory.rejected, (state) => {
            state.loading = false
        });


        builder.addCase(editInventory.pending, (state) => {
            state.loading = true
        });
        builder.addCase(editInventory.fulfilled, (state) => {
            state.loading = false

        });
        builder.addCase(editInventory.rejected, (state) => {
            state.loading = false
        });
    
    },
});

export const { clearExtraReducers } = inventorySlice.actions;


export default inventorySlice.reducer;
